import {
  LIST_ALERT_SUMMARY,
  UPDATE_ALERT_SUMMARY,
  LIST_ALERT,
  CREATE_ALERT,
  UPDATE_ALERT,
  DELETE_ALERT,
  ALERT_HISTORY,
  UPDATE_ALERT_HISTORY,
  UPDATE_FILE_HISTORY,
  ALERT_HISTORY_NOTIFICATION,
  LIST_ALERT_MUTATION,
  UPDATE_ALERT_MUTATION,
} from '../constant'
import axios from 'axios'
import * as REPO from '../helper/main'

const localKey = 'token'

export const getAlertSummary = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(LIST_ALERT_SUMMARY + param, config_token)
}

export const updateAlertSummary = (data, id, event_type) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(
    UPDATE_ALERT_SUMMARY + id + '/' + event_type,
    data,
    config_token
  )
}

export const getListAlert = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_ALERT, config_token)
}

export const getAlertHistory = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
    // maxContentLength: Infinity,
    // maxBodyLength: Infinity,
  }
  let param = REPO.bikinParam(body)
  //
  return axios.get(ALERT_HISTORY + param, config_token)
}

export const getAlertMutation = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)

  return axios.get(LIST_ALERT_MUTATION + param, config_token)
}

export const updateAlertMutation = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(UPDATE_ALERT_MUTATION, body, config_token)
}

export const getAlertHistoryNotification = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(ALERT_HISTORY_NOTIFICATION + param, config_token)
}

export const postAlert = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_ALERT, data, config_token)
}

export const updateAlert = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_ALERT + id, data, config_token)
}
export const updateAlertHistory = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_ALERT_HISTORY + id, data, config_token)
}
export const updateFileHistory = (data, id, type = 'img') => {
  let config_token = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + localStorage.getItem(localKey),
    },
  }
  // switch (type) {
  //   case 'xlsx':
  //     config_token.headers['Content-Type'] =
  //       'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  //     break

  //   default:
  //     config_token.headers['Content-Type'] = 'multipart/form-data'
  //     break
  // }
  //
  return axios.post(UPDATE_FILE_HISTORY + id, data, config_token)
}

export const deleteAlert = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_ALERT + id, config_token)
}

export const markNotificationsAsRead = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(`${process.env.VUE_APP_URL_ENDPOINT}/mw-mapping-alert/mark-as-read`, data, config_token)
}

export const markAllNotificationsAsRead = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(`${process.env.VUE_APP_URL_ENDPOINT}/mw-mapping-alert/mark-all-as-read`, data, config_token)
}
